<template>
  <b-container>
    <b-row>
      <b-col class="center-base all" style="min-height: 750px;">
        <div class="text-center">
          <span class="display-4">Partnership</span>
          <b-img
            :src="require('@/assets/img/fullwidth/about-us.png')"
            style="width: 100%;"
          />
          <p>Tell us about your company and we’ll be in touch.</p>
        </div>
      </b-col>

      <b-col class="center-base all">
        <div class="form-corporate px-5 py-3">
          <FormCorporate />
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// external dependencies

// custom component
import FormCorporate from '@/templates/FormCorporate'

// api call

export default {
  name: 'Corporate',
  components: {
    FormCorporate
  },
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.form-corporate {
  border-radius: 15px;
  background-color: #fafafa;
  box-shadow: 0px 1px 6px 0px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/views/Corporate.vue